(function() {
  var yearUtil;

  yearUtil = exports;

  yearUtil.salesYear = function() {
    var today, useThisDate;
    today = new Date();
    useThisDate = new Date(today);
    useThisDate.setMonth(today.getMonth() + 5);
    useThisDate.setDate(today.getDate() + 15);
    return useThisDate.getFullYear();
  };

}).call(this);
